import React from 'react';

export const OrderConfirmationSVG = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="107" height="117" viewBox="0 0 107 117">
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          fill="#78C8F5"
          d="M86.805 107.991h-62.61a8.882 8.882 0 0 1-6.568-2.482 8.593 8.593 0 0 1-2.623-6.425l5.933-61.57c.608-4.469 4.598-7.732 9.174-7.503h50.778c4.563-.21 8.531 3.048 9.138 7.504l5.97 61.57a8.593 8.593 0 0 1-2.624 6.424 8.882 8.882 0 0 1-6.568 2.482z"
        />
        <path
          fill="#D9EFFC"
          d="M71.448 45c-1.962 0-3.552-1.518-3.552-3.391V20.413c0-4.24-4.369-7.63-9.732-7.63h-5.328c-5.327 0-9.732 3.39-9.732 7.63v21.196c0 1.873-1.59 3.391-3.552 3.391C37.591 45 36 43.482 36 41.609V20.413C35.93 12.46 43.477 6 52.765 6h5.328C67.453 6 75 12.46 75 20.413v21.196C75 43.482 73.41 45 71.448 45z"
        />
        <path
          fill="#C5E7FB"
          d="M15.004 99c-.071 2.43.88 4.78 2.623 6.486a8.835 8.835 0 0 0 6.568 2.505h62.61a8.835 8.835 0 0 0 6.568-2.505A8.717 8.717 0 0 0 95.996 99l-1.18-12H16.184l-1.18 12z"
        />
      </g>
      <g fillRule="nonzero" transform="translate(59 69)">
        <rect width="47.059" height="47.059" fill="#49A1EA" rx="23.529" />
        <path
          fill="#FFF"
          d="M21.487 32.941a1.221 1.221 0 0 1-.874-.377l-6.197-6.386a1.306 1.306 0 0 1 .065-1.734 1.213 1.213 0 0 1 1.682-.067l5.188 5.37 10.3-14.177c.266-.365.7-.557 1.14-.502.44.055.818.347.992.766.174.42.117.903-.149 1.269L22.48 32.43c-.218.295-.547.48-.905.511h-.087z"
        />
      </g>
      <path fill="#C5E7FB" fillRule="nonzero" d="M81 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
      <path
        fill="#C5E7FB"
        d="M26.563 16.682a4 4 0 1 0-3.126-7.364 4 4 0 0 0 3.126 7.364zM5.172 28.636a3 3 0 1 0-2.344-5.523 3 3 0 0 0 2.344 5.523z"
      />
      <path
        fill="#B1DFFA"
        fillRule="nonzero"
        d="M99.64 14.997a8.258 8.258 0 0 0 2.991 5.465.697.697 0 0 1 .24.74.686.686 0 0 1-.59.497 8.1 8.1 0 0 0-5.377 2.96.678.678 0 0 1-.73.243.69.69 0 0 1-.492-.598 8.26 8.26 0 0 0-2.923-5.445.697.697 0 0 1-.24-.74.686.686 0 0 1 .59-.497 8.1 8.1 0 0 0 5.378-2.96.677.677 0 0 1 .674-.178c.24.07.424.266.479.513zM6.3 4.039a9.936 9.936 0 0 0 6.46 3.777.83.83 0 0 1 .732.618.843.843 0 0 1-.33.906 10.116 10.116 0 0 0-3.73 6.542.835.835 0 0 1-.61.742.822.822 0 0 1-.894-.334 9.936 9.936 0 0 0-6.46-3.777.83.83 0 0 1-.733-.618.843.843 0 0 1 .329-.906 10.116 10.116 0 0 0 3.73-6.542.835.835 0 0 1 .61-.742.822.822 0 0 1 .895.334zM100.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z"
      />
    </g>
  </svg>
);
